// MERKEZİ HATA KAYDI (frontend) — kullanıcıya hata gösterilen yerden sessizce çağrılır.
// error_logs tablosuna yazar (RLS: kullanıcı yalnız kendi hatasını ekleyebilir, okuyamaz).
import { supabase } from "@/integrations/supabase/client";

export async function logClientError(tool: string, message: string, detail?: Record<string, unknown>): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await (supabase as any).from("error_logs").insert({
      user_id: user.id,
      tool,
      source: "frontend",
      message: String(message).slice(0, 600),
      detail: detail ?? null,
      url: typeof location !== "undefined" ? location.pathname : null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 200) : null,
    });
  } catch { /* sessiz — log hatası kullanıcıyı etkilemesin */ }
}
